import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import managementStyles from '../ManagementPages.module.css';
import CustomTasksToggle from '../../components/CustomTasksToggle'
import { setCompletedTaskTypeCounts, setDataList, setSelectAll, setSelectedRows, setFilterItem, setPendingTaskTypeCounts, setReloadTaskList } from './TasksSlice';
import TaskListPanel from './TaskListPanel';
import TaskFilterView from './TaskFilterView';
import useAxios from '../../services/AxiosConfig';
import { setTaskListCount } from '../../slicers/sidebarSlice';
import taskStyles from './Tasks.module.css';
import {Form } from 'react-bootstrap';
import { useWebSocket } from '../../services/webSocket/useWebSocket';

const Tasks = () => {
    const dispatch = useDispatch();
    const taskListPanel = useSelector((state) => state.taskListPanel);
    const axiosConfig = useSelector((state) => state.axiosConfig);
    const axios = useAxios(axiosConfig.envURL);
    const userId = useSelector((state) => state.userInfo.id);
    const { receivedMessage } = useWebSocket();

    useEffect(() => {
        if (receivedMessage?.type === 'staff_task') {
            dispatch(setReloadTaskList(true));
        }
      }, [receivedMessage]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const staffTasksResponse = await axios.get(`staffTasks/list/${userId}`);
                if (staffTasksResponse.data.data) {
                    const tasksWithChecked = staffTasksResponse.data.data.map(task => {
                        const dueDate = task.dueDate ? new Date(task.dueDate) : null;
                        const currentDate = new Date();

                        let isDueDatePassed = false;
                        let isDueSoon = false;

                        if (dueDate instanceof Date && !isNaN(dueDate)) { 
                            isDueDatePassed = dueDate < currentDate;
                            isDueSoon = !isDueDatePassed && (dueDate - currentDate) <= 24 * 60 * 60 * 1000;
                        }


                        return {
                            ...task,
                            checked: false,
                            isDueDatePassed,
                            isDueSoon,
                        };
                    });

                    tasksWithChecked.sort((a, b) => {
                        const dateA = new Date(a.dueDate);
                        const dateB = new Date(b.dueDate);

                        // Prioritize tasks with passed due dates
                        if (a.isDueDatePassed && !b.isDueDatePassed) return -1;
                        if (!a.isDueDatePassed && b.isDueDatePassed) return 1;

                        if (dateA < dateB) return 1;
                        if (dateA > dateB) return -1;
                        
                        // If dates are the same, sort by type (assuming type is a string)
                        if (a.type < b.type) return -1;
                        if (a.type > b.type) return 1;

                        return 0;
                    });

                    const newCount = tasksWithChecked.filter(task => task.status === 'Pending').length;
                    dispatch(setTaskListCount(newCount));
                    dispatch(setDataList(tasksWithChecked));
                    const pendingCount = tasksWithChecked?.filter(task => task.status === 'Pending').length;
                    dispatch(setPendingTaskTypeCounts(pendingCount));
                    const completedCount = tasksWithChecked?.filter(task => task.status === 'Completed').length;
                    dispatch(setCompletedTaskTypeCounts(completedCount));
                    dispatch(setReloadTaskList(false));

                } else {
                    console.error('Error fetching Task List');
                }
            } catch (error) {
                console.error('Error:', error);
            }
        };
        if (userId && taskListPanel.reloadTaskList) {
            fetchData();
        }
    }, [userId, taskListPanel.reloadTaskList, dispatch, axios]);

    const handleToggle = (value) => {
        dispatch(setFilterItem({ key: "filter", value: value }));
        dispatch(setSelectedRows([]));
        dispatch(setSelectAll(false));
        const count = taskListPanel?.dataList?.filter(task => task.status === value).length;
        if (value === 'Pending')
            dispatch(setPendingTaskTypeCounts(count));
        else if (value === 'Completed')
            dispatch(setCompletedTaskTypeCounts(count));
    };

    const handleSelectAll = () => {
        dispatch(setSelectAll(!taskListPanel.selectAll));
      };

    return (
        <div className={managementStyles.MiddleContent}>
            <div style={{padding:"10px 0", display:"flex"}}>
            <CustomTasksToggle label1="Pending" label2="Completed" handleToggle={handleToggle} />
            </div>
            <TaskFilterView />
            <Form.Check className={taskStyles.selectAllFormCheck}
                type="checkbox" style={{ marginLeft: '10px', marginBottom: '10px' }}
                label="Select All"
                checked={taskListPanel?.selectAll}
                onChange={handleSelectAll}
            />
            <TaskListPanel />
        </div>
    );
}

export default Tasks;